<template>
  <div>
    <b-button variant="primary" @click="showModal = true">
      <i class="fas fa-external-link-alt"></i>
    </b-button>

    <b-modal v-model="showModal" title="CSV Export" hide-footer>
      <div v-if="loading">Please Wait...</div>
      <div v-else>
        <h5>Fields to Export</h5>
        <b-form-checkbox :checked="true" disabled>Image ID</b-form-checkbox>
        <b-form-checkbox :checked="true" disabled>Acquired Date</b-form-checkbox>
        <b-form-checkbox :checked="true" disabled>Net Sale Price</b-form-checkbox>
        <b-form-checkbox :checked="true" disabled>Royalty %</b-form-checkbox>
        <b-form-checkbox :checked="true" disabled>Royalty Amount in USD</b-form-checkbox>
        <b-form-checkbox v-model="settings['watermark_url']" @change="updateRemoteSettings">Asset Watermark URL</b-form-checkbox>
        <b-form-checkbox v-model="settings['original_filename']" @change="updateRemoteSettings">Original Filename</b-form-checkbox>
        <b-form-checkbox v-model="settings['asset_version_size']" @change="updateRemoteSettings">Version Size</b-form-checkbox>
        <b-form-checkbox v-model="settings['usage']" @change="updateRemoteSettings">Usage</b-form-checkbox>
        <b-form-checkbox v-model="settings['exclusivity']" @change="updateRemoteSettings">Exclusivity</b-form-checkbox>

        <h5 class="mt-3">Range</h5>

        <div>
          <date-range-picker
              v-model="dateRange"
              :ranges="false"
              :locale-data="pickerLocale"
              @finish-selection="finishSelection"
              ref="pickerInput"
          ></date-range-picker>
        </div>

        <div>
          <a :href="exportUrl" class="btn btn-sm btn-primary" target="_blank">Export CSV</a>
        </div>
      </div>

    </b-modal>
  </div>
</template>

<script>
import normalize from "json-api-normalize";
import Attributes from "../../../models/Attributes";
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'


export default {
  components: { DateRangePicker },

  props: ['formStartDate', 'formEndDate'],

  data() {
    return {
      showModal: false,
      settings: {
        watermark_url: false,
        original_filename: false,
        asset_version_size: false,
        usage: false,
        exclusivity: false,
      },

      loading: false,
      showDatePicker: false,
      dateRange: {
        startDate: this.formStartDate,
        endDate: this.formEndDate
      }
    }
  },

  watch: {
    showModal(val) {
      if (val) {
        this.loadData()
      }
    }
  },

  computed: {
    exportUrl() {
      let start = this.dateRange.startDate
      if (start instanceof Date) {
        start = start.toLocaleDateString('en-us')
      }

      let end = this.dateRange.endDate
      if (end instanceof Date) {
        end = end.toLocaleDateString('en-us')
      }

      const url = new URL(`${location.protocol + '//' + location.host}${location.pathname}.csv`);
      url.searchParams.append("range", `${start} - ${end}`);
      return url.href
    },

    pickerLocale() {
      return {
        format: 'mm/dd/yyyy'
      }
    }
  },

  methods: {
    finishSelection(data) {
      // console.log(data.toLocaleDateString('en-us'));
    },

    save() {
      this.showModal = false
    },

    updateRemoteSettings() {
      this.$http.post("/export_setting.json", {"contributor_export_setting": this.settings}).then(fulfilled => {
        const settings = normalize(fulfilled.body).get(Attributes.contributorExportSettings);
        this.updateSettings(settings)
      }, rejected => {
        console.log(rejected);
      })
    },

    loadData() {
      this.loading = true

      this.$http.get("/export_setting.json").then(fulfilled => {
        const settings = normalize(fulfilled.body).get(Attributes.contributorExportSettings);
        this.updateSettings(settings)
        this.loading = false
      }, rejected => {
        console.log(rejected);
      })
    },

    updateSettings(data) {
      this.settings = data
    }
  }
}
</script>